import { Flex, Image, Layout } from '@contiple/antd-ds';
import { useNavigate } from 'react-router-dom';

const { Header } = Layout;

const HeaderBar = () => {
  const navigate = useNavigate();

  return (
    <Header
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 0,
        justifyContent: 'space-between',
      }}>
      <Flex
        align="center"
        justify="center"
        style={{
          cursor: 'pointer',
          lineHeight: '22px',
        }}
        onClick={() => navigate('/')}>
        <Image src="/images/logo.png" alt="logo" height={22} preview={false} />
      </Flex>
      {/* Header Right 
      <Flex align="center" gap={16}>
        <ThemeToggle />
        <ComponentSizeToggle />
      </Flex>
      */}
    </Header>
  );
};

export default HeaderBar;
